import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=8bd2eb5a&scoped=true"
import script from "./Deposit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=8bd2eb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2eb5a",
  null
  
)

export default component.exports